import { render, staticRenderFns } from "./BuyerSettingsOrganizationTab.vue?vue&type=template&id=1673f48e&"
import script from "./BuyerSettingsOrganizationTab.vue?vue&type=script&lang=js&"
export * from "./BuyerSettingsOrganizationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports